import { computed } from '@angular/core';

import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

import type { ChatMessage, RunStatus } from '@core/tellent-assistant-types';

type RunState = {
  messages: ChatMessage[];
  runStatus: RunStatus;
  currentThreadId: string | null;
  lastError: string | null;
  runStartedAt: number | null;
  runDurationMs: number | null;
};

const initialState: RunState = {
  messages: [],
  runStatus: 'idle',
  currentThreadId: null,
  lastError: null,
  runStartedAt: null,
  runDurationMs: null,
};

export const AssistantRunStore = signalStore(
  { providedIn: 'root' },
  withState<RunState>(initialState),
  withComputed(state => ({
    isRunning: computed(() => state.runStatus() === 'running'),
  })),
  withMethods(store => ({
    resetForThread(threadId: string | null): void {
      patchState(store, {
        currentThreadId: threadId,
        messages: [],
        lastError: null,
        runStatus: 'idle',
        runStartedAt: null,
        runDurationMs: null,
      });
    },
    replaceMessages(messages: ChatMessage[]): void {
      patchState(store, { messages });
    },
    markRunStart(): void {
      patchState(store, {
        runStatus: 'running',
        runStartedAt: Date.now(),
        runDurationMs: null,
        lastError: null,
      });
    },
    markRunEnd(): void {
      const started = store.runStartedAt();
      patchState(store, {
        runStatus: 'idle',
        runDurationMs: started != null ? Date.now() - started : null,
        runStartedAt: null,
      });
    },
    markRunError(message: string): void {
      const started = store.runStartedAt();
      patchState(store, {
        runStatus: 'error',
        lastError: message,
        runDurationMs: started != null ? Date.now() - started : null,
        runStartedAt: null,
      });
    },
  })),
);
